import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment.prod';

@Injectable({ providedIn: 'root' })
export class BpAddressService {
  private URL = ''

  constructor(private http: HttpClient) { this.URL = environment.domain}

  getAddresByBp() {
    const url_api = this.URL + 'api/em/business_partner_address/get'
    return this.http.get(url_api);
  }
  getAddresByBpCb() {
    const url_api = this.URL + 'api/em/business_partner_address/get_cb'
    return this.http.get(url_api);
  }
  setAddresByBp(data:any) {
    const url_api = this.URL + 'api/em/business_partner_address/set'
    return this.http.post(url_api, data);
  }
  updateAddresByBp(id:any, data:any) {
    const url_api = this.URL + 'api/em/business_partner_address/put/' + id
    return this.http.put(url_api, data);
  }
  deleteAddresByBp(id:any) {
    const url_api = this.URL + 'api/em/business_partner_address/delete/' + id
    return this.http.delete(url_api);
  }

  // STORE
  onValidateStore(data:any) {
    const url_api = this.URL + 'api/em/store/validate_store_time/'
    return this.http.post(url_api, data);
  }
}
